import { ShieldAlert } from 'lucide-react';
import { PageHeader } from '@/shared/components/ui/PageHeader';
import { AuditLogViewer } from '../components/AuditLogViewer';
import { AccountingSubNav } from '../../accounting/components/AccountingSubNav';

export function AuditPage() {
  return (
    <div className="text-slate-900 dark:text-slate-100">
      <AccountingSubNav />
      <div className="space-y-4 pb-16">
        <PageHeader icon={ShieldAlert} eyebrow="Finance" title="Audit Trail" description={<>Immutable log of all accounting actions — who did what, when</>} />
        <AuditLogViewer />
      </div>
    </div>
  );
}
